import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetGoLiveChecklistQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  openOrdersWhere: Types.OrdersDocumentFilterInput;
  pickedOrdersWhere: Types.OrdersDocumentFilterInput;
  signedInUsersFirst: Types.Scalars['Int']['input'];
  signedInUsersWhere: Types.UserDocumentFilterInput;
}>;


export type GetGoLiveChecklistQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomersConnection', totalCount: number } | null, items?: { __typename?: 'ItemsConnection', totalCount: number } | null, priceGroups?: { __typename?: 'PriceGroupsConnection', totalCount: number } | null, orders?: { __typename?: 'OrdersConnection', totalCount: number } | null, pickedOrders?: { __typename?: 'OrdersConnection', totalCount: number } | null, users?: { __typename?: 'UsersConnection', totalCount: number, nodes?: Array<{ __typename?: 'UserDocument', email: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const GetGoLiveChecklistDocument = new TypedDocumentString(`
    query GetGoLiveChecklist($first: Int!, $openOrdersWhere: OrdersDocumentFilterInput!, $pickedOrdersWhere: OrdersDocumentFilterInput!, $signedInUsersFirst: Int!, $signedInUsersWhere: UserDocumentFilterInput!) {
  customers(first: $first) {
    totalCount
  }
  items(first: $first) {
    totalCount
  }
  priceGroups(first: $first) {
    totalCount
  }
  orders(first: $first, where: $openOrdersWhere) {
    totalCount
  }
  pickedOrders: orders(first: $first, where: $pickedOrdersWhere) {
    totalCount
  }
  users(first: $signedInUsersFirst, where: $signedInUsersWhere) {
    nodes {
      email
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetGoLiveChecklist: build.query<GetGoLiveChecklistQuery, GetGoLiveChecklistQueryVariables>({
      query: (variables) => ({ document: GetGoLiveChecklistDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetGoLiveChecklistQuery, useLazyGetGoLiveChecklistQuery } = injectedRtkApi;
